import { CustomClaimMessages, TranslationCustomClaimMessages } from "../interfaces";

export const messages: TranslationCustomClaimMessages = {
  [CustomClaimMessages.defaultClaims]: "Derecho común de grupo",
  [CustomClaimMessages.additionalUserClaim]: "Privilegio personalizado",
  [CustomClaimMessages.restrictedUserClaim]: "Restricción personalizada"
};